import { PaletteOptions } from '@mui/material';

export const darkPalette: PaletteOptions = {
    mode: 'dark',
    background: {
        default: '#011224',
        paper: '#011224',
    },
    text: {
        primary: '#FFFFFF',
        secondary: '#808892',
    },
    primary: {
        main: '#0573E4',
    },
};
